import React, { memo } from 'react'
import Image from 'next/image'
import { FormattedMessage } from 'react-intl'
import NumberFormat from 'react-number-format'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid2'
import Typography from '@mui/material/Typography'
import usePageProps from 'hooks/usePageProps'
import { useSelector } from 'react-redux'
import sx from './styles'
import VehicleFullName from '../VehicleFullName'

const SummaryVehicleCard = ({
  vehicle, variant = 'normal', basePrice = true, sxProps = sx.root, noWrap,
}) => {
  const { personalInformation } = useSelector((s) => s.checkout.steps)
  const { temporaryImageDomain } = usePageProps()
  const image = vehicle?.images[0]
  const wrapContent = noWrap
    ? true : !personalInformation.isCompleted || personalInformation.isExpanded

  const vehicleImage = (
    <Image
      src={`${temporaryImageDomain}/300x100/${image?.filename}`}
      fill
      style={{ objectFit: 'cover' }}
      placeholder="blur"
      alt={vehicle?.name}
      blurDataURL={`${temporaryImageDomain}/40x40/filters:blur(90)/${image?.filename}`}
      unoptimized
    />
  )

  const renderFullName = (
    <VehicleFullName
      sxProps={sx.vehicleText}
      vehicle={vehicle}
      noWrap={!(wrapContent)}
    />
  )

  return (
    <Box sx={sxProps}>
      <Grid container>
        {variant !== 'simplified' && (wrapContent) && (
          <Grid
            size="auto"
            sx={sx.imageContainer}
          >
            <Box sx={sx.noImage}>
              {vehicleImage}
            </Box>
          </Grid>
        )}

        <Grid size="grow">
          {renderFullName}
          {variant !== 'simplified' && basePrice && (wrapContent) && (
            <Typography
              variant="caption"
              component="p"
              sx={sx.priceText}
            >
              <FormattedMessage
                id="CHECKOUT_BASE_PRICE"
                values={{
                  price: <NumberFormat
                    value={parseInt(vehicle?.price)}
                    displayType="text"
                    thousandSeparator
                    prefix="$"
                  />,
                }}
              />
            </Typography>
          )}
        </Grid>
      </Grid>
    </Box>
  )
}

export default memo(SummaryVehicleCard)
